<template>
  <div id="scheduleDetailOtherTab_compreResult">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="!Object.keys(eventCompModeDatas).length"
    />
    <template v-else>
      <!-- 游泳 A|T 高山滑雪 综合成绩 -->
      <EVENTCOP_MODE_3
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_3>

      <!-- 射箭 男子|女子 个人排名赛 混合成绩 特殊处理 -->
      <EVENTCOP_MODE_10
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_10' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_10>

      <EVENTCOP_MODE_24
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_24' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
        :isCombatFlag="localDataProp.isCombatFlag"
      ></EVENTCOP_MODE_24>

      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'
import EVENTCOP_MODE_10 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_10.vue'
import EVENTCOP_MODE_24 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_24.vue'
export default {
  name: 'scheduleDetailOtherTab_compreResult',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_3,
    EVENTCOP_MODE_10,
    EVENTCOP_MODE_24,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
        isCombatFlag: false, //对抗|非对抗
      }),
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('compreResult 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          // if (
          //   ['SAL', 'WSU', 'ROL', 'EQU'].includes(
          //     this.currSportsDetail.sportsId
          //   ) &&
          //   newVal.datas
          // ) {
          //   // 都是 mode_24 视图
          //   let datas = newVal.datas['result_combined']
          //   datas.annotation = datas.annotation ? datas.annotation : []
          //   this.eventCompModeDatas = JSON.parse(
          //     JSON.stringify(datas ? datas : {})
          //   )
          // }
          if (
            this.result_combined.sportsIds.includes(
              this.currSportsDetail.sportsId
            ) &&
            newVal.datas &&
            newVal.datas[this.result_combined.key]
          ) {
            // 射箭 男子|女子 个人排名赛
            // 游泳 综合成绩  mode_3:A 分组预赛|半决赛; mode_3:T 分组预赛|半决赛
            // 高山滑雪
            // 花样滑冰
            // 帆船
            // 武术
            // 轮滑
            // 马术
            let datas = newVal.datas[this.result_combined.key]
            if (datas) {
              datas.annotation = datas.annotation ? datas.annotation : []
              this.eventCompModeDatas = JSON.parse(JSON.stringify(datas))
            } else {
              this.eventCompModeDatas = {}
            }
          } else {
            this.eventCompModeDatas = JSON.parse(
              JSON.stringify(newVal.datas ? newVal.datas : {})
            )
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tabTypeKey: 'compreResult',
      eventCompModeDatas: null,
      result_combined: {
        sportsIds: [
          'SJP',
          'FRS',
          'ARC',
          'SWM',
          'ALP',
          'FSK',
          'SAL',
          'WSU',
          'ROL',
          'EQU',
          'WTL',
        ],
        key: 'result_combined',
      },
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // window.scrollTo(0, Math.floor(30.776 * this.vw2px))
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#scheduleDetailOtherTab_compreResult {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
